import { lazy } from 'react';

const TimesheetUpload = lazy(() => import('./TimesheetUpload'));

export default TimesheetUpload;
